import { Group, NumberInput, Stack, Text } from "@mantine/core";
import {
  HOME_SCREEN_MAX_AGENDA_SESSIONS,
  HOME_SCREEN_SECTION_DEFAULTS,
} from "@congrs/schemas";

/** The row's one-line summary: how long the day's list runs. */
const Summary = ({ options }) =>
  `${options.count} ${options.count === 1 ? "session" : "sessions"} at a time`;

const Settings = ({ options, onChange }) => (
  <Stack gap="md" mt="md" pl={34}>
    <Group gap="xl" wrap="nowrap">
      <Text size="sm" fw={500} w={110} style={{ flexShrink: 0 }}>
        How many
      </Text>
      <NumberInput
        size="xs"
        w={90}
        min={1}
        max={HOME_SCREEN_MAX_AGENDA_SESSIONS}
        clampBehavior="strict"
        value={options.count}
        onChange={(count) =>
          onChange({ ...options, count: Number(count) || options.count })
        }
      />
      <Text size="xs" c="dimmed">
        Starts at the live session, or the next one up — up to this many.
      </Text>
    </Group>
  </Stack>
);

const agendaSectionSettings = {
  defaults: HOME_SCREEN_SECTION_DEFAULTS.agenda,
  Settings,
  Summary,
};

export default agendaSectionSettings;
